import { ReactElement, useState } from "react";
import { AppInputProps } from "../../interfaces/ComponentInterfaces";
import { IconWrapper } from "../../customHooks/useIcon";

const AppInput = ({
  leftIcon: LeftIcon = null,
  rightIcon: RightIcon = null,
  placeholder = "",
  topLabel: TopLabel = null,
  bottomLabel: BottomLabel = null,
  type,
  disabled = false,
  name,
  value,
  onChange,
  onBlur,
    error,
  className,
}: AppInputProps): ReactElement => {
  const [localType, setLocalType] = useState<string>(type);

  const handlePasswordView = (type: string) => setLocalType(type);

  return (
    <div className="flex flex-col gap-2 w-full">
      {TopLabel && typeof TopLabel === "string" ? (
        <span className="text-sm text-primary-blackMain font-semibold">{TopLabel}</span>
      ) : (
        TopLabel
      )}
      <div
        className={`input-wrapper ${
          error ? "border-red-500" : "border-primary-border"
        }  ${className}`}
      >
        {LeftIcon && <IconWrapper icon={LeftIcon} size={20} className="text-accent-light3" />}
        <input
          className="input-style"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          type={type === "password" ? localType : type}
        />
        {(type === "password" &&
          (localType === "password" ? (
            <span
              onClick={() => handlePasswordView("text")}
              className="cursor-pointer text-xs text-primary-placeholder"
            >
              Show
            </span>
          ) : (
            <span
              onClick={() => handlePasswordView("password")}
              className="cursor-pointer text-xs text-primary-placeholder"
            >
              Hide
            </span>
          ))) ||
          (RightIcon && (
            <IconWrapper icon={RightIcon} size={20} className="text-primary-blackLighter" />
          ))}
      </div>
      {BottomLabel && typeof BottomLabel === "string" ? (
        <span className="text-sm text-primary-blackLighter">{BottomLabel}</span>
      ) : (
        BottomLabel
      )}
      {error && <span className={`text-red-500 text-sm ${error ? 'mb-5' : ''}`}>{error}</span>}
    </div>
  );
};

export default AppInput;
